import { simpleDecode, simpleEncode, uint8ArrayDecodeToBase64Text } from './aws-kms';

const AWS = require('aws-sdk/dist/aws-sdk-react-native');

const ddb = new AWS.DynamoDB();
const docClient = new AWS.DynamoDB.DocumentClient();

const tableName = 'user';

export const scan = async (inputParams) => {
  const { callback } = inputParams;
  const limit = inputParams.limit || 10;
  const params = { TableName: tableName, Limit: limit };

  const scanResults = [];
  let items = null;
  // let count = 0;

  // do {
  // count += 1;
  items = await docClient.scan(params).promise();
  items.Items.forEach((item) => scanResults.push(decodeUserInfo(item)));
  params.ExclusiveStartKey = items.LastEvaluatedKey;
  // } while (typeof items.LastEvaluatedKey != 'undefined' && count < limit);

  // debug-console.log('scanResults=', scanResults);

  callback(scanResults);
};

const decodeUserInfo = (item) => {
  const binaryData = item.zip;

  // 1. User KMS to decrypt:
  // const latin1Text = await base64rawDecryptToUserData(userData);
  // 2. Use simple decode:

  const byteArr = simpleDecode(binaryData);
  const userDataText = uint8ArrayDecodeToBase64Text(new Uint8Array(byteArr));

  // debug-console.log('decodeUserInfo: userDataText=' + userDataText.length);
  const userData = JSON.parse(userDataText);
  userData.updatedAt = item.updatedAt;
  userData.roles = []; // to avoid render error
  // item.zip = JSON.parse(userData);
  return userData;
};

// get encrypted data and decrypt:
export const getListUserDB = (inputParams) => {
  const { userId, callback } = inputParams;
  // debug-console.log('getListUserDB : userId=' + userId);

  const params = userId
    ? {
        TableName: tableName,
        Key: {
          userId: { S: userId.toString() },
        },
        ProjectionExpression: 'zip', // 'tree, zip'
      }
    : {
        TableName: tableName,
        // Key: {
        //   userId: { S: userId.toString() },
        // },
        Limit: 50,
        ProjectionExpression: 'zip', // 'tree, zip'
      };

  // Call DynamoDB to read the item from the table
  ddb.getItem(params, async (err, data) => {
    if (err) {
      console.error('Error loading data : \n' + JSON.stringify(err));
    } else {
      // debug-console.log('Load data Success for user: ' + userId, data);
      // if (data.Item && data.Item.tree) {
      // 	userData = data.Item.tree.S;
      if (data.Item && data.Item.zip) {
        const binaryData = data.Item.zip.B;

        // 1. User KMS to decrypt:
        // const latin1Text = await base64rawDecryptToUserData(userData);
        // 2. Use simple decode:

        const byteArr = simpleDecode(binaryData);
        const userData = uint8ArrayDecodeToBase64Text(new Uint8Array(byteArr));

        // debug-console.log('getListUserDB: userData=' + userData.length);
        callback(userData);
      } else {
        // debug-console.log('Loaded ZIP Data is empty for user : ', userId);
        getRawDBData(userId, callback);
        // callback('[]');
      }
      
    }
  });
  return '';
};

// get encrypted data and decrypt:
export function getUser(userId, callback) {
  // debug-console.log('getUser : userId=' + userId);
  if (!userId) {
    alert('userId is null');
    return;
  }

  const params = {
    TableName: tableName,
    Key: {
      userId: { S: userId.toString() },
    },
    ProjectionExpression: 'zip', // 'tree, zip'
  };

  // Call DynamoDB to read the item from the table
  ddb.getItem(params, async (err, data) => {
    // $.unblockUI();
    // let userData = [];
    if (err) {
      console.error('Error loading data : \n' + JSON.stringify(err));
    } else {
      // debug-console.log('Load data Success for user: ' + userId);
      // if (data.Item && data.Item.tree) {
      // 	userData = data.Item.tree.S;
      if (data.Item && data.Item.zip) {
        const binaryData = data.Item.zip.B;

        // 1. User KMS to decrypt:
        // const latin1Text = await base64rawDecryptToUserData(userData);
        // 2. Use simple decode:

        const byteArr = simpleDecode(binaryData);
        const userData = uint8ArrayDecodeToBase64Text(new Uint8Array(byteArr));

        // debug-console.log('getUser: userData=' + userData.length);
        callback(userData);
      } else {
        // debug-console.log('Loaded ZIP Data is empty for user : ', userId);
        // getRawDBData(userId, callback);
        callback('[]');
      }
      
    }
  });
}

const getRawDBData = (userId, callback) => {
  // debug-console.log('getRawDBData : userId=' + userId);
  if (!userId) {
    alert('userId is null');
    return;
  }

  const params = {
    TableName: tableName,
    Key: {
      userId: { S: userId.toString() },
    },
    ProjectionExpression: 'tree', // 'tree, zip'
  };

  // Call DynamoDB to read the item from the table
  ddb.getItem(params, async (err, data) => {
    if (err) {
      console.error('getRawDBData: Error loading data : \n' + JSON.stringify(err));
    } else {
      // debug-console.log('getRawDBData: Load data Success for user: ' + userId);
      if (data.Item && data.Item.tree) {
        const userData = data.Item.tree.S;
        // debug-console.log('getRawDBData: userData=' + userData.length);
        callback(userData);
      } else {
        // debug-console.log('Loaded Data is empty for user : ', userId);
        callback('[]');
      }
      
    }
  });
};

export const saveUserEncrypted = async (user) => {
  // debug-console.log('saveUserEncrypted: 1. user=', user);
  const { userId } = user;
  if (!userId) {
    alert('user null');
    return;
  }
  const base64Text = simpleEncode(JSON.stringify(user));

  // debug-console.log('saveUserEncrypted: 2. encoded to base64Text(DB saving)=' + base64Text.length);
  // // debug-console.log(base64Text);

  // const testByteArray = textEncodeToByteArray(base64Text);
  // // debug-console.log('saveUserEncrypted: 3. base64 -> encode to arr (to test sending), length='+testByteArray.length);

  const params = {
    TableName: tableName,
    Key: {
      userId: { S: userId },
    },
    UpdateExpression: 'SET zip = :val , updatedAt = :now ',
    ExpressionAttributeValues: {
      ':val': { B: base64Text },
      ':now': { N: Date.now().toString() },
    },
    ReturnValues: 'UPDATED_NEW',
  };

  // Call DynamoDB to add the item to the table

  const response = ddb.updateItem(params, (err, data) => {
    if (err) {
      // debug-console.log('Error', err);
      alert('Error : ' + userId + ' : ' + JSON.stringify(err));
    } else {
      // debug-console.log(data);
      // alert('Lưu dữ liệu thành công cho người dùng ' + userId);
    }
    // callback(false); // turn off loader
  });
  // debug-console.log('saveUserEncrypted: <-- 4. await UpdateDB response=');
  // debug-console.log(response);
};

export const saveUser = async (user) => {
  const { userId } = user;
  if (!userId) {
    return alert('Empty user');
  }
  // debug-console.log('saveUser: user=', user);
  const profile = JSON.stringify(user);

  // used to test: const decrypted = encrypted.then(decrypt_KMS);
  const params = {
    TableName: tableName,
    Key: {
      userId: { S: user.userId },
    },
    UpdateExpression: 'SET profile = :profile , updatedAt = :now ',
    ExpressionAttributeValues: {
      ':profile': { S: profile },
      ':now': { N: Date.now().toString() },
    },
    ReturnValues: 'UPDATED_NEW',
  };

  // debug-console.log(params);
  // Call DynamoDB to add the item to the table

  const response = ddb.updateItem(params, (err, data) => {
    if (err) {
      // debug-console.log('Error', err);
      alert('Error : ' + userId + ' : ' + JSON.stringify(err));
    } else {
      // debug-console.log(data);
      alert('Lưu dữ liệu thành công cho người dùng ' + userId);
    }
  });
  return response;
};

// function deleteItem() {
//   const params = {
//     TableName: tableName,
//     Key: {
//       userId: { S: 'VALUE' },
//     },
//   };

//   // Call DynamoDB to delete the item from the table
//   ddb.deleteItem(params, (err, data) => {
//     if (err) {
//       // debug-console.log('Error', err);
//     } else {
//       // debug-console.log('Success', data);
//     }
//   });
// }

// function putItem(data) {
//   if (!data) {
//     data = JSON.stringify(cy.elements().jsons());
//   }
//   // debug-console.log(data);
//   const params = {
//     TableName: tableName,
//     Item: {
//       userId: { S: userId },
//       updatedAt: { N: Date.now().toString() },
//       tree: { S: data },
//     },
//   };
//   // Call DynamoDB to add the item to the table
//   ddb.putItem(params, (err, data) => {
//     if (err) {
//       // debug-console.log('Error', err);
//     } else {
//       // debug-console.log('Success', data);
//     }
//   });
// }

export const query = () => {
  // const { userId, callback } = inputParams;
  /* This example queries items in the Music table. The table has a partition key and sort key (Artist and SongTitle), but this query only specifies the partition key value. It returns song titles by the artist named "No One You Know". */

  const params = {
    ExpressionAttributeValues: {
      // ':v1': {
      //   S: '1',
      // },
    },
    KeyConditionExpression: '', // 'userId = :v1',
    // IndexName: 'updatedAt',
    // ScanIndexForward : false, // true = ASC
    Limit: '10',
    ProjectionExpression: 'zip',
    TableName: tableName,
  };
  ddb.query(params, (err, data) => {
    if (err) console.log(err, err.stack);
    else console.log(data);
    // data = {
    //  ConsumedCapacity: {
    //  },
    //  Count: 2,
    //  Items: [
    // 	{
    //    "SongTitle": {
    // 	 S: "Call Me Today"
    // 	}
    //   }
    //  ],
    //  ScannedCount: 2
    // }
  });
};
